"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscussionWrapper = exports.StyledButton = exports.ShareCTAs = exports.ShareText = exports.ShareWrapper = exports.DotSeparator = exports.AuthorLink = exports.CategoryLink = exports.Image = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const get_cms_asset_1 = __importDefault(require("@src/helpers/get-cms-asset"));
const not_found_1 = __importDefault(require("@src/components/pages/not-found"));
const RenderHtml_1 = __importDefault(require("@src/components/elements/RenderHtml"));
const timestamp_1 = __importDefault(require("@src/components/modules/global/timestamp"));
const elements_1 = require("@src/components/elements");
const excerpt_html_1 = __importDefault(require("excerpt-html"));
const disqus_react_1 = require("disqus-react");
const react_helmet_1 = require("react-helmet");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
// import { Link } from '@src/components/elements'
const BodyWrapper = styled_components_1.default.div `
	font-size: 1.2em;
	margin-top: 2rem;
	& img {
		width: auto;
		max-width: 100%;
		margin: 2em auto;
		display: block;
	}
	& .imageCaption {
		margin: -1em 0 2em 0;
		text-align: center;
		font-size: 1.1em;
		opacity: 0.8;
		line-height: 1.1;
	}
	& iframe {
		width: 100%;
		margin: 2em auto;
		display: block;
		min-height: 400px;
	}
	& h1,
	& h2,
	& h3,
	& h4,
	& h5,
	& h6 {
		padding-top: 1.8em;
		padding-bottom: 1.5em;
		font-weight: bold;
		color: ${props => props.theme.color.brand1};
	}
	& h1 {
		font-size: 1.6em;
	}
	& h2 {
		font-size: 1.5em;
	}
	& h3 {
		font-size: 1.3em;
	}
	& h4 {
		font-size: 1.1em;
	}
	& h5 {
		font-size: 1em;
	}
	& h6 {
		font-size: 1em;
	}
	& ul,
	& ol {
		padding-top: 1.8em;
		padding-bottom: 1.5em;
	}
	& blockquote {
		border-left: 4px solid ${props => props.theme.color.gray5};
		color: ${props => props.theme.color.gray7};
		font-size: 1.025em;
		padding-left: 1.125em;
		margin: 0 2em 1.333333333em 2em;
	}
	& table {
		margin: 2em 0 2em;
		padding-top: 0.5em;
		padding-bottom: 0.5em;
		max-width: 100%;
	}
	& td {
		margin: 0.3em 0.6em 0 0;
		padding: 0.5em 2em 0.5em 0;
	}
	& tr {
		border-bottom: 1px solid ${props => props.theme.color.gray2};
	}
	& a {
		text-decoration: underline;
	}
	& .partner {
		padding-top: 2em;
	}
	& .magazine-widget {
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		margin-top: 3em;
		margin-bottom: 3em;
		padding: 1em 2em;
		border: 1px solid ${props => props.theme.color.gray5};
		border-radius: ${props => props.theme.borderRadius.large};
		background: ${props => props.theme.color.white};

		${(0, styled_breakpoints_1.up)('md')} {
			width: 80%;
		}
	}
	& .magazine-title {
		font-size: 1.1em;
		font-weight: bold;
		display: inline-block;
	}
	& .magazine-article {
		.magazine-title {
			padding-top: 0.4em;
			padding-bottom: 0.4em;
		}
	}
	& .magazine-widget-headline {
		font-size: 0.9em;
		padding-top: 0.2em;
		padding-bottom: 0.3em;
		color: ${props => props.theme.color.gray8};
	}
`;
const Subheadline = styled_components_1.default.div `
	text-align: center;
	display: block;
	font-weight: bold;
	color: ${props => props.theme.color.gray6};
`;
exports.Image = styled_components_1.default.img `
	margin: 2em auto;
	display: block;
	max-width: 100%;
`;
// TODO: post filter by categories
// export const CategoryLink = styled(Link)`
exports.CategoryLink = styled_components_1.default.span `
	display: inline-block;
	margin-top: 0.5em;
	&:hover {
		text-decoration: none;
	}
	text-transform: uppercase;
`;
exports.AuthorLink = styled_components_1.default.span `
	display: inline-block;
	margin-top: 0.5em;
	&:hover {
		text-decoration: none;
	}
	color: ${props => props.theme.color.brand3};
	text-transform: uppercase;
`;
exports.DotSeparator = styled_components_1.default.span `
	display: inline-block;
	margin: 0 0.5em;
`;
exports.ShareWrapper = styled_components_1.default.div `
	margin: 4em 0 4em 0;
`;
exports.ShareText = styled_components_1.default.div `
	text-align: center;
	font-weight: bold;
	font-size: 1.3em;
`;
exports.ShareCTAs = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	margin: 2em 0 2em 0;
	flex-wrap: wrap;
`;
exports.StyledButton = (0, styled_components_1.default)(elements_1.Button) `
	font-weight: bold;
	text-transform: uppercase;
	margin: 0.5em;
	&:link,
	&:visited,
	&:focus {
		line-height: 1.7em;
		color: ${props => props.theme.color.white};
	}

	&:hover,
	&:active {
		line-height: 1.7em;
		color: ${props => props.theme.color.white};
	}

	&& {
		padding-top: 8px !important;
	}
`;
exports.DiscussionWrapper = styled_components_1.default.div `
	padding: 2em 0 0 0;
`;
// TODO: next/previous articles
// TODO: similar articles
const Post = () => {
    const theme = (0, styled_components_1.useTheme)();
    const location = (0, react_router_dom_1.useLocation)();
    // @ts-ignore
    const { slug } = (0, react_router_1.useParams)();
    const { data: post, error } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.magazinePost.key, slug);
    const currentURL = `${process.env.PUBLIC_URL}${encodeURI(location.pathname)}`;
    let ldJson;
    if (post) {
        ldJson = {
            '@context': 'https://schema.org',
            '@type': 'NewsArticle',
            mainEntityOfPage: {
                '@type': 'WebPage',
                '@id': currentURL,
            },
            headline: post.title,
            image: (0, get_cms_asset_1.default)(post.coverImage, 'large'),
            datePublished: post.date,
            dateModified: post.date,
            author: {
                '@type': 'Person',
                name: post.author || 'Pracuj.sk',
            },
            publisher: {
                '@type': 'Organization',
                name: 'Pracuj.sk',
                logo: {
                    '@type': 'ImageObject',
                    url: `${process.env.PUBLIC_URL}/media/images/logo-square.png`,
                },
            },
        };
    }
    return ((0, jsx_runtime_1.jsx)(elements_1.Holder, { marginVertical: true, children: (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, md: 18, children: [error && (0, jsx_runtime_1.jsx)(not_found_1.default, {}), post && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_helmet_1.Helmet, { children: (0, jsx_runtime_1.jsx)("script", { type: "application/ld+json", children: JSON.stringify(ldJson).replace(/</g, '\\u003c') }) }), (0, jsx_runtime_1.jsx)(elements_1.Head, { type: "article", title: post.title, description: (0, excerpt_html_1.default)(post.content, { pruneLength: 300 }), imageUrl: (0, get_cms_asset_1.default)(post.coverImage, 'large') }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { children: (0, jsx_runtime_1.jsx)(elements_1.Title, { level: 1, type: "secondary", children: post.title }) }) }), (0, jsx_runtime_1.jsxs)(Subheadline, { children: [(0, jsx_runtime_1.jsx)("time", { dateTime: post.date, children: (0, jsx_runtime_1.jsx)(timestamp_1.default, { value: post.date, type: "humanized" }) }), (0, jsx_runtime_1.jsx)(exports.DotSeparator, { children: "\u25AA" }), (0, jsx_runtime_1.jsx)(exports.CategoryLink, { children: post.category }), post.author && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.DotSeparator, { children: "\u25AA" }), (0, jsx_runtime_1.jsx)(exports.AuthorLink, { children: post.author })] }))] }), (0, jsx_runtime_1.jsx)(exports.Image, { src: (0, get_cms_asset_1.default)(post.coverImage, 'body'), srcSet: `${(0, get_cms_asset_1.default)(post.coverImage, 'body')} 1x, ${(0, get_cms_asset_1.default)(post.coverImage, 'body_2x')} 2x`, alt: post.title }), (0, jsx_runtime_1.jsxs)(BodyWrapper, { children: [(0, jsx_runtime_1.jsx)(RenderHtml_1.default, { html: post.content, extended: true }), post.partnerHostname && ((0, jsx_runtime_1.jsxs)("div", { className: "partner", children: [(0, jsx_runtime_1.jsxs)("strong", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.continue_to_article" }), ' ', (0, jsx_runtime_1.jsx)("a", { href: `${post.partnerLink}?ref=pracuj.sk`, target: "_blank", rel: "noreferrer", children: post.title }), ' '] }), "[", post.partnerHostname, "]"] }))] }), (0, jsx_runtime_1.jsxs)(exports.ShareWrapper, { children: [(0, jsx_runtime_1.jsx)(exports.ShareText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.share_message" }) }), (0, jsx_runtime_1.jsxs)(exports.ShareCTAs, { children: [(0, jsx_runtime_1.jsx)(exports.StyledButton, { type: "primary", size: "large", href: `http://twitter.com/intent/tweet?url=${currentURL}`, target: "_blank", style: { background: theme.color.twitter, borderColor: theme.color.twitter }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.share_twitter" }) }), (0, jsx_runtime_1.jsx)(exports.StyledButton, { type: "primary", size: "large", href: `https://www.facebook.com/sharer.php?u=${currentURL}`, target: "_blank", style: { background: theme.color.facebook, borderColor: theme.color.facebook }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.share_facebook" }) })] })] }), (0, jsx_runtime_1.jsx)(exports.DiscussionWrapper, { children: (0, jsx_runtime_1.jsx)(disqus_react_1.DiscussionEmbed, { shortname: "pracuj-sk", config: {
                                        url: currentURL,
                                        identifier: slug,
                                        title: post.title,
                                        language: 'cz_CS',
                                    } }) })] }))] }) }) }));
};
exports.default = Post;
